import React, { useEffect, useState } from "react";
import { TESTIMONIALS } from "../mock";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const total = TESTIMONIALS.length;

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % total), 6000);
    return () => clearInterval(id);
  }, [total]);

  const visible = [
    TESTIMONIALS[idx % total],
    TESTIMONIALS[(idx + 1) % total],
    TESTIMONIALS[(idx + 2) % total]
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">Testimonials</div>
            <h2 className="display section-underline mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
              Client Voices
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => setIdx((idx - 1 + total) % total)} className="w-11 h-11 rounded-full border border-slate-300 grid place-items-center hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-colors">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={() => setIdx((idx + 1) % total)} className="w-11 h-11 rounded-full border border-slate-300 grid place-items-center hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-colors">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((t, i) => (
            <article key={`${t.name}-${i}`} className="relative bg-slate-50 border border-slate-200 rounded-xl p-7 hover:border-yellow-500 hover:shadow-xl transition-all">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-yellow-600/20" />
              <div className="flex items-center gap-1 text-yellow-600">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="mt-4 text-slate-700 leading-relaxed">“{t.text}”</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-yellow-600 to-yellow-800 grid place-items-center text-white font-bold">
                  {t.name.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                </div>
                <div>
                  <div className="font-bold text-slate-900">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
